import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../lib/axios';
import { ApiEndpoints } from '../../../../constants/endpoints/apiEndpoints';
import { AnnouncementManagementModel } from '../types';

async function getCurrentAnnouncement(): Promise<AnnouncementManagementModel> {
  return (await getAxios().get(ApiEndpoints.crmAdmin.announcements.getCurrent)).data;
}

export function useCurrentAnnouncementQuery() {
  return useQuery({
    queryKey: ['currentAnnouncement'],
    retry: false,
    queryFn: getCurrentAnnouncement
  });
}
